import { Link } from "react-router-dom";
import { Star, ShoppingBag, Sparkles } from "lucide-react";
import { fileUrl } from "@/lib/api";
import { fmtINR, fmtUSD } from "@/lib/money";

export default function ProductCard({ product, onAdd }) {
  const price = product.price;
  const original = product.original_price;
  const discount = original && original > price ? Math.round(((original - price) / original) * 100) : 0;
  const img = product.images?.[0] ? fileUrl(product.images[0]) : "https://images.unsplash.com/photo-1605292356183-a77d0a9c9d1d?w=800&q=80";

  return (
    <div data-testid={`product-card-${product.id}`} className="group bg-white rounded-2xl shadow-warm shadow-warm-hover border border-[#FFD1A6] overflow-hidden transition-all duration-300 flex flex-col">
      <Link to={`/product/${product.id}`} className="relative block zoom-parent aspect-[4/5] bg-[#FDEFDD]">
        <img src={img} alt={product.name} className="w-full h-full object-cover zoom-img" loading="lazy" />
        {product.is_featured && (
          <span className="absolute top-3 left-3 bg-[#FFB300] text-[#2C1810] text-[10px] font-semibold tracking-wider uppercase px-3 py-1 rounded-full pulse-badge flex items-center gap-1">
            <Sparkles className="w-3 h-3" /> Festive Pick
          </span>
        )}
        {discount > 0 && (
          <span className="absolute top-3 right-3 bg-[#E65C00] text-white text-xs font-semibold px-3 py-1 rounded-full">
            {discount}% OFF
          </span>
        )}
        <button
          data-testid={`quick-add-${product.id}`}
          onClick={(e) => { e.preventDefault(); onAdd?.(product); }}
          className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all bg-[#4A148C] hover:bg-[#6A2AB0] text-[#FFCF52] w-11 h-11 rounded-full flex items-center justify-center shadow-lg"
          aria-label="Add to cart"
        >
          <ShoppingBag className="w-5 h-5" />
        </button>
      </Link>
      <div className="p-5 flex-1 flex flex-col">
        <div className="text-[10px] tracking-widest uppercase text-[#4A148C] font-body mb-1">{product.category}</div>
        <Link to={`/product/${product.id}`} className="font-display text-xl text-[#2C1810] hover:text-[#E65C00] transition-colors line-clamp-1">
          {product.name}
        </Link>
        <p className="text-sm text-[#5B3D2A] font-body line-clamp-2 mt-1 flex-1">{product.description}</p>
        <div className="flex items-center justify-between mt-4">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-display text-2xl text-[#E65C00] font-semibold">₹{fmtINR(price)}</span>
              {discount > 0 && (
                <span className="text-sm text-[#5B3D2A]/60 line-through">₹{fmtINR(original)}</span>
              )}
            </div>
            <div className="text-[10px] font-body text-[#5B3D2A]/70 mt-0.5">≈ ${fmtUSD(price)} USD</div>
          </div>
          <div className="flex items-center gap-1 text-[#FFB300]">
            <Star className="w-4 h-4 fill-current" />
            <span className="text-xs text-[#2C1810] font-body">4.8</span>
          </div>
        </div>
      </div>
    </div>
  );
}
